goog.provide("shadow.js.shim.module$$mui$material$Badge");
goog.provide("module$shadow_js_shim_module$$mui$material$Badge");
shadow.js.shim.module$$mui$material$Badge = shadow.js.nativeProvides["@mui/material/Badge"] = shadow$bridge("@mui/material/Badge");
module$shadow_js_shim_module$$mui$material$Badge.default = shadow.js.shim.module$$mui$material$Badge;
